/* ============================================================ */
/* DAIGLE THEME - JS                                             */
/* Microinteractions, financing calculator, reveal on scroll     */
/* ============================================================ */

(function() {
  'use strict';

  // ============ Maillage interne : filet de sécurité de relocalisation ============
  // Les liens internes issus des réglages sont désormais localisés côté Liquid
  // (snippet `daigle-localized-url` : préfixe de langue ET handle traduit), donc
  // le HTML servi est déjà correct pour Google. Ce bloc ne reste qu'en filet de
  // sécurité pour les liens injectés plus tard (apps tierces, HTML collé dans
  // une page/description, nouveau réglage oublié). Il ne traduit PAS les handles
  // (il ne peut pas) : il ajoute seulement le préfixe de langue, ce qui produit
  // une 301 vers le handle traduit. À terme il devrait ne rien avoir à corriger.
  (function relocalizeInternalLinks() {
    var root = document.documentElement.getAttribute('data-locale-root');
    if (!root || root === '/') return; // locale primaire (FR) : rien à faire
    var prefix = root + '/';
    var selector = 'a[href^="/pages/"], a[href^="/collections/"], a[href^="/products/"], a[href^="/blogs/"]';
    document.querySelectorAll(selector).forEach(function(a) {
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) !== '/') return;
      // Déjà préfixé (/en/... ) : on ne touche à rien, sinon on créerait /en/en/.
      if (href === root || href.slice(0, prefix.length) === prefix) return;
      a.setAttribute('href', root + href);
    });
  })();

  // Format des nombres selon la langue de la page (fr-CA : « 12 000 », en-CA : « 12,000 »)
  var DG_NUM_LOCALE = /^en/i.test(document.documentElement.lang || '') ? 'en-CA' : 'fr-CA';

  // ============ Lucide icons (safe init) ============
  function safeLucide() {
    if (typeof lucide !== 'undefined' && lucide.createIcons) {
      try { lucide.createIcons(); } catch(e) { console.warn('[Daigle] Lucide init failed:', e); }
    }
  }
  safeLucide();
  window.addEventListener('load', () => setTimeout(safeLucide, 50));

  // ============ Mobile drawer ============
  const burger = document.querySelector('[data-dg-burger]');
  const drawer = document.querySelector('[data-dg-drawer]');
  const closeDrawer = document.querySelector('[data-dg-close-drawer]');
  if (burger && drawer) {
    burger.addEventListener('click', () => {
      drawer.classList.add('dg-open');
      document.body.style.overflow = 'hidden';
    });
    closeDrawer?.addEventListener('click', () => {
      drawer.classList.remove('dg-open');
      document.body.style.overflow = '';
    });
    drawer.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
      drawer.classList.remove('dg-open');
      document.body.style.overflow = '';
    }));
  }

  // ============ Scroll progress + header state ============
  const progressBar = document.querySelector('[data-dg-progress]');
  const header = document.querySelector('[data-dg-header]');
  const heroSection = document.querySelector('[data-dg-hero]');

  function onScroll() {
    const scrolled = window.scrollY;
    const max = document.body.scrollHeight - window.innerHeight;
    if (progressBar) {
      progressBar.style.width = max > 0 ? (scrolled / max * 100) + '%' : '0%';
    }
    if (header) {
      if (heroSection) {
        const heroBottom = heroSection.offsetTop + heroSection.offsetHeight - 80;
        if (scrolled < heroBottom) {
          header.classList.add('dg-over-hero');
          header.classList.remove('dg-scrolled');
        } else {
          header.classList.remove('dg-over-hero');
          header.classList.add('dg-scrolled');
        }
      } else {
        // No hero on this page = always light scrolled style
        header.classList.add('dg-scrolled');
      }
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // ============ Hero parallax ============
  const heroBg = document.querySelector('[data-dg-hero-bg]');
  if (heroBg) {
    window.addEventListener('scroll', () => {
      if (window.scrollY < window.innerHeight) {
        heroBg.style.transform = `translateY(${window.scrollY * 0.3}px)`;
      }
    }, { passive: true });
  }

  // ============ Reveal on scroll ============
  const revealEls = document.querySelectorAll('.dg-reveal');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('dg-visible');
          entry.target.querySelectorAll('[data-dg-counter]').forEach(animateCounter);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -50px 0px' });

    revealEls.forEach(el => observer.observe(el));

    // Reveal already-in-viewport elements on load
    window.addEventListener('load', () => {
      revealEls.forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          el.classList.add('dg-visible');
          el.querySelectorAll('[data-dg-counter]').forEach(animateCounter);
        }
      });
    });
  } else {
    revealEls.forEach(el => {
      el.classList.add('dg-visible');
      el.querySelectorAll('[data-dg-counter]').forEach(animateCounter);
    });
  }

  // Safety net: force-reveal anything still hidden after 3s
  setTimeout(() => {
    revealEls.forEach(el => {
      if (!el.classList.contains('dg-visible')) el.classList.add('dg-visible');
    });
  }, 3000);

  // ============ Counter animation ============
  function animateCounter(el) {
    const target = parseInt(el.dataset.dgCounter, 10);
    const suffix = el.dataset.dgSuffix || '';
    if (isNaN(target)) return;
    const duration = 2000;
    const start = performance.now();
    function tick(now) {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const value = Math.floor(eased * target);
      el.textContent = value.toLocaleString(DG_NUM_LOCALE) + suffix;
      if (progress < 1) requestAnimationFrame(tick);
      else el.textContent = target.toLocaleString(DG_NUM_LOCALE) + suffix;
    }
    requestAnimationFrame(tick);
  }

  // ============ Magnetic buttons ============
  document.querySelectorAll('.dg-magnetic').forEach(btn => {
    let rafId = null;
    btn.addEventListener('mousemove', (e) => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        const rect = btn.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        btn.style.transform = `translate(${x * 0.12}px, ${y * 0.2}px)`;
      });
    });
    btn.addEventListener('mouseleave', () => {
      if (rafId) cancelAnimationFrame(rafId);
      btn.style.transform = '';
    });
  });

  // ============ Financing calculator ============
  const priceSlider = document.querySelector('[data-dg-price]');
  const downSlider = document.querySelector('[data-dg-down]');
  const termSlider = document.querySelector('[data-dg-term]');
  const priceDisplay = document.querySelector('[data-dg-price-display]');
  const downDisplay = document.querySelector('[data-dg-down-display]');
  const termDisplay = document.querySelector('[data-dg-term-display]');
  const monthlyDisplay = document.querySelector('[data-dg-monthly-display]');
  const financedDisplay = document.querySelector('[data-dg-financed-display]');
  const interestDisplay = document.querySelector('[data-dg-interest-display]');
  const rateInput = document.querySelector('[data-dg-rate]');

  function calcFinance() {
    if (!priceSlider || !downSlider || !termSlider) return;
    const price = parseInt(priceSlider.value);
    const downPct = parseInt(downSlider.value);
    const termMonths = parseInt(termSlider.value);
    const annualRate = parseFloat(rateInput?.value || 7.99) / 100;
    const monthlyRate = annualRate / 12;
    const downAmount = price * (downPct / 100);
    const financed = price - downAmount;
    const monthly = financed * (monthlyRate * Math.pow(1 + monthlyRate, termMonths)) / (Math.pow(1 + monthlyRate, termMonths) - 1);
    const totalInterest = (monthly * termMonths) - financed;

    if (priceDisplay) priceDisplay.textContent = price.toLocaleString(DG_NUM_LOCALE);
    if (downDisplay) downDisplay.textContent = downPct;
    if (termDisplay) termDisplay.textContent = termMonths;
    if (monthlyDisplay) monthlyDisplay.textContent = Math.round(monthly).toLocaleString(DG_NUM_LOCALE);
    if (financedDisplay) financedDisplay.textContent = Math.round(financed).toLocaleString(DG_NUM_LOCALE);
    if (interestDisplay) interestDisplay.textContent = Math.round(totalInterest).toLocaleString(DG_NUM_LOCALE);
  }
  [priceSlider, downSlider, termSlider].forEach(s => s && s.addEventListener('input', calcFinance));
  if (priceSlider) calcFinance();

  // ============ Consentement cookies (icône -> panneau au clic seulement) ============
  (function() {
    const STORAGE_KEY = 'dg_cookie_consent'; // 'granted' | 'denied' — absent = consentement implicite
    const getPanel = () => document.querySelector('[data-dg-cookie]');

    // Transmet le choix aux outils de suivi : API Confidentialite des clients
    // de Shopify (pixels, Meta, Google via l'app) + Consent Mode de gtag.
    function applyConsent(value) {
      const granted = value === 'granted';
      try {
        if (window.gtag) {
          window.gtag('consent', 'update', {
            ad_storage: granted ? 'granted' : 'denied',
            ad_user_data: granted ? 'granted' : 'denied',
            ad_personalization: granted ? 'granted' : 'denied',
            analytics_storage: granted ? 'granted' : 'denied'
          });
        }
      } catch (e) {}
      try {
        const setConsent = () => {
          const cp = window.Shopify && window.Shopify.customerPrivacy;
          if (cp && typeof cp.setTrackingConsent === 'function') {
            cp.setTrackingConsent({ analytics: granted, marketing: granted, preferences: granted, sale_of_data: granted }, () => {});
            return true;
          }
          return false;
        };
        if (!setConsent() && window.Shopify && window.Shopify.loadFeatures) {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => setConsent());
        }
      } catch (e) {}
    }

    window.dgSetCookieConsent = function(value) {
      try { localStorage.setItem(STORAGE_KEY, value); } catch(e) {}
      applyConsent(value);
      const panel = getPanel();
      if (panel) {
        panel.classList.add('dg-hidden-out');
        setTimeout(() => panel.setAttribute('hidden', ''), 300);
      }
    };

    window.dgOpenCookiePanel = function() {
      const panel = getPanel();
      if (panel) {
        panel.removeAttribute('hidden');
        panel.classList.remove('dg-hidden-out');
      }
    };

    // Premiere visite (aucun choix enregistre) : on montre le bandeau.
    // Choix deja fait : on le re-applique a chaque page, sans rien afficher.
    let stored = null;
    try { stored = localStorage.getItem(STORAGE_KEY); } catch(e) {}
    if (stored === 'granted' || stored === 'denied') {
      applyConsent(stored);
    } else {
      applyConsent('denied');
      setTimeout(() => { if (!document.querySelector('[data-dg-cookie]:not([hidden])')) window.dgOpenCookiePanel(); }, 800);
    }
  })();

  // ============ Announcement bar close ============
  document.querySelectorAll('[data-dg-close-announcement]').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.closest('[data-dg-announcement]')?.remove();
    });
  });

  // ============ Boutons téléphone : appel direct (tel:) ============
  // Tout lien dont le texte visible est uniquement un numéro (10-11 chiffres)
  // devient un lien tel: s'il ne l'est pas déjà — surtout utile sur mobile.
  document.querySelectorAll('a:not([href^="tel:"])').forEach(a => {
    const txt = (a.textContent || '').trim();
    if (!/^[+()\d\s.–—-]+$/.test(txt)) return; // texte = format téléphone seulement
    const digits = txt.replace(/\D/g, '');
    if (digits.length < 10 || digits.length > 11) return;
    const tel = digits.length === 10 ? '+1' + digits : '+' + digits;
    a.setAttribute('href', 'tel:' + tel);
  });

  // ============ Bulles des trust badges (tap mobile) ============
  // La bulle est la sœur suivante du badge ; on l'ouvre/ferme via .is-open.
  document.querySelectorAll('.dg-trust-badge').forEach(badge => {
    const tip = badge.nextElementSibling;
    if (!tip || !tip.classList.contains('dg-trust-badge__tip')) return;
    badge.addEventListener('click', e => {
      e.preventDefault();
      const willOpen = !tip.classList.contains('is-open');
      document.querySelectorAll('.dg-trust-badge__tip.is-open').forEach(t => t.classList.remove('is-open'));
      if (willOpen) tip.classList.add('is-open');
    });
  });
  document.addEventListener('click', e => {
    if (!e.target.closest('.dg-trust-badge') && !e.target.closest('.dg-trust-badge__tip')) {
      document.querySelectorAll('.dg-trust-badge__tip.is-open').forEach(t => t.classList.remove('is-open'));
    }
  });

  // ============ Scrollers inventaire (homepage, recherche, produits liés) ============
  function dgInitInvScrollers() {
    document.querySelectorAll('[data-inv-track]').forEach(function(track) {
      if (track.dataset.dgInvInit) return;
      track.dataset.dgInvInit = '1';
      var scroller = track.closest('.dg-inv-scroller') || track.parentElement;
      var arrow = scroller ? scroller.querySelector('[data-inv-arrow]') : null;
      function update() {
        if (!arrow) return;
        var scrollable = (track.scrollWidth - track.clientWidth) > 8;
        var atEnd = track.scrollLeft >= (track.scrollWidth - track.clientWidth - 8);
        arrow.hidden = !scrollable || atEnd;
      }
      if (arrow) {
        arrow.addEventListener('click', function() {
          var card = track.firstElementChild;
          var step = card ? (card.getBoundingClientRect().width + 24) : (track.clientWidth * 0.8);
          track.scrollBy({ left: step, behavior: 'smooth' });
        });
      }
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      setTimeout(update, 400);
      update();
    });
  }
  dgInitInvScrollers();
  window.addEventListener('load', function() { setTimeout(dgInitInvScrollers, 200); });
  document.addEventListener('shopify:section:load', dgInitInvScrollers);

  // Re-init icons one last time after DOM is fully loaded
  setTimeout(safeLucide, 150);

})();
